import * as React from 'react';

interface RejoinIconProps {
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

const RejoinIcon = ({ color = '#000', ...props }: RejoinIconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    height="1em"
    width="1em"
    {...props}
  >
    <path
      d="M2.338 3.255v17.49a1.5 1.5 0 0 0 2.209 1.322l16.323-8.745a1.5 1.5 0 0 0 0-2.644L4.547 1.933a1.5 1.5 0 0 0-2.209 1.322Z"
      style={{
        fill: 'none',
        stroke: color,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5px',
      }}
    />
  </svg>
);

export default RejoinIcon;
